import { getLocalizedStrings } from '@/localization/localization-store'
import { useRef, useEffect, useState } from 'preact/hooks'
import AnimateHeight, { Height } from 'react-animate-height'

export type CartDrawerHeaderProps = {
  title?: string
  emptyTitle?: string
  itemCount: number
  error?: string | null
}

export default function CartDrawerHeader({
  itemCount,
  title,
  emptyTitle,
  error
}: CartDrawerHeaderProps) {
  const strings = getLocalizedStrings()
  const [height, setHeight] = useState<Height>('auto')
  const container = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const element = container.current!

    const resizeObserver = new ResizeObserver(() => {
      setHeight(element.clientHeight)
    })

    resizeObserver.observe(element)

    return () => resizeObserver.disconnect()
  }, [])

  return (
    <p className='px-6 text-xl'>
      {itemCount === 0 ? (
        (emptyTitle ?? 'Your Cart is Empty')
      ) : (
        <>
          {title ?? 'Your Cart:'}
          <span className='font-bold'>
            {' '}
            {`${itemCount} ${itemCount === 1 ? (strings.cartItem ?? 'Item') : (strings.cartItemPlural ?? 'Items')}`}
          </span>
        </>
      )}
      <AnimateHeight contentRef={container} disableDisplayNone height={height}>
        {error && (
          <div className='pt-3'>
            <span className='block rounded border border-error-red bg-error-red/[.05] p-2 text-xs font-bold tracking-wider text-error-red'>
              {error}
            </span>
          </div>
        )}
      </AnimateHeight>
    </p>
  )
}
